import React, { useState } from 'react';
import { Box, Button, Collapse, Typography } from '@mui/material';
import { programRules } from '../utils/referral';
import { tokens } from '../theme';

// The partner program's rules: the first lines open, the rest behind "Все условия".
const ProgramRules = ({ program, open: startOpen = false }) => {
  const [open, setOpen] = useState(startOpen);
  const rules = programRules(program || {});
  const item = (text, i) => (
    <Box component="li" key={i} sx={{ mb: 0.75, color: tokens.ink, fontSize: '0.875rem', lineHeight: 1.5 }}>{text}</Box>
  );
  return (
    <Box sx={{ p: 2, borderRadius: `${tokens.radiusSm}px`, bgcolor: tokens.primaryTint, border: `1px solid ${tokens.border}` }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Условия партнёрской программы</Typography>
      <Box component="ol" sx={{ m: 0, pl: 2.5 }}>
        {rules.slice(0, 2).map(item)}
      </Box>
      <Collapse in={open}>
        <Box component="ol" start={3} sx={{ m: 0, pl: 2.5 }}>
          {rules.slice(2).map((t, i) => item(t, i + 2))}
        </Box>
      </Collapse>
      <Button size="small" onClick={() => setOpen((v) => !v)} sx={{ mt: 0.5, px: 0 }}>
        {open ? 'Свернуть' : 'Все условия'}
      </Button>
    </Box>
  );
};

export default ProgramRules;
